import React from "react";
import { useNavigate } from "react-router-dom"; // Import navigate
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { AuthGuard } from "../App";
import { RoleGuard } from "../App";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashAlt, faExclamationTriangle, faTimes, faCheck } from "@fortawesome/free-solid-svg-icons";
import { StandardURL } from "../App";


const DeleteVideo = ({ videoId }) => {
  const navigate = useNavigate(); // Initialize navigate

  const handleDelete = () => {
    const videoId = localStorage.getItem("deleteVideoId");
    const token = localStorage.getItem("token");
    // Perform delete request
    axios
      .delete(
        `${StandardURL}/iNyumba/videos/delete/${videoId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((response) => {
        toast.success(response.data.response);
        // Navigate back
        navigate(-1);
      })
      .catch((error) => {
        toast.error(error.response.data.response);
        console.error("Error deleting video:", error);
        // Navigate back
        navigate(-1);
      });
  };

  const handleCancel = () => {
    // Navigate back
    navigate(-1);
  };

  return (
    <RoleGuard>
      <AuthGuard>
        <div className="min-h-screen bg-gradient-to-br from-red-50 to-orange-100 flex items-center justify-center p-4 sm:p-6 lg:p-8">
          <div className="max-w-md w-full bg-white p-8 rounded-xl shadow-2xl border border-gray-200 text-center">
            {/* --- Header & Icon --- */}
            <div className="mb-6">
              <FontAwesomeIcon icon={faExclamationTriangle} className="text-red-500 text-6xl mb-4 animate-bounce-slow" />
              <h1 className="text-4xl font-extrabold text-gray-900 mb-2">Confirm Deletion</h1>
            </div>

            {/* --- Confirmation Message --- */}
            <p className="text-lg text-gray-700 mb-8 leading-relaxed">
              Are you absolutely sure you want to delete this video? This action cannot be undone.
            </p>

            {/* --- Action Buttons --- */}
            <div className="flex flex-col sm:flex-row justify-center gap-4">
              <button
                onClick={handleDelete}
                className="inline-flex items-center justify-center px-8 py-4 border border-transparent text-lg font-semibold rounded-lg shadow-md text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 transition duration-300 ease-in-out transform hover:scale-105"
              >
                <FontAwesomeIcon icon={faCheck} className="mr-3 text-white text-xl" />
                Yes, Delete It
              </button>

              <button
                onClick={handleCancel}
                className="inline-flex items-center justify-center px-8 py-4 border border-gray-300 text-lg font-semibold rounded-lg shadow-md text-gray-800 bg-gray-100 hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-400 transition duration-300 ease-in-out transform hover:scale-105"
              >
                <FontAwesomeIcon icon={faTimes} className="mr-3 text-gray-600 text-xl" />
                No, Keep It
              </button>
            </div>
          </div>
        </div>
      </AuthGuard>
    </RoleGuard>
  );
};

export default DeleteVideo;
